module.exports = __webpack_public_path__ + "img/IMG_3549.2c755b3e.jpg";